module.exports = __webpack_public_path__ + "static/media/Inter-Medium.592a30dc.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Medium.woff
// module id = 697
// module chunks = 21